module.exports = __webpack_public_path__ + "img/outlander2022_in.5dba8638.jpg";